export const loaderConstants = {
    IS_LOADING: 'IS_LOADING',
    CLEAR: 'CLEAR'
};
